module.exports = __webpack_public_path__ + "img/female.54c6687b.png";